import React, { useState, useRef, useCallback } from 'react';
import Avatar from './Avatar';
import Menu from './Menu';
import useOnClickOutside from '@app/components/hooks/useOnClickOutside';
import { Client } from '@app/types/api';

type AvatarMenuProps = {
    name: string;
    headerImgUrl: string;
    clients: Array<Client>;
    clientId: string;
};

const AvatarMenu = ({
    name,
    headerImgUrl,
    clients,
    clientId,
}: AvatarMenuProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const closeMenu = useCallback(() => setIsOpen(false), []);
    const toggleMenu = useCallback(() => setIsOpen(p => !p), []);
    const container = useRef(null);
    useOnClickOutside(container, closeMenu);

    return (
        <div className="gds-avatar" ref={container}>
            <Avatar
                src={headerImgUrl}
                alt={name}
                onClick={toggleMenu}
            />
            <Menu
                name={name}
                open={isOpen}
                clients={clients}
                clientId={clientId}
                onClose={closeMenu}
                headerImgUrl={headerImgUrl}
            />
        </div>
    );
};

export default AvatarMenu;
